define('BookingEngine/app-FlightUpgrades/main',[],function () {
    return {
        ActivateFlightUpgrades: function () {
            //Cancel flight upgrades.
            $('.cancelFlightUpgrades').on('click', function () {
                $(this).closest('.flights').find('.bookFlightUpgrades').hide();
                $(this).closest('.flightsBodyButton').find('.toFlightUpgrades').find('.cancelFlightUpgrades').hide();
                $(this).closest('.flightsBodyButton').find('.toFlightUpgrades').find('.upgradeFlight').show();
            });

            //Close flight upgrades.
            $('.closeFlightUpgrades').on('click', function () {
                $(this).closest('.flights').find('.bookFlightUpgrades').hide();
                $(this).parents('.bookFlightUpgrades').prev('.flightsBodyButton').find('.toFlightUpgrades').find('.cancelFlightUpgrades').hide();
                $(this).parents('.bookFlightUpgrades').prev('.flightsBodyButton').find('.toFlightUpgrades').find('.upgradeFlight').show();
            });

            //When flight upgrades have loaded on the page, give the user the option to filter those results by clicking on the buttons.
            //showUpgradeOutbound will show all upgrades available on outbound flights.
            //showUpgradeInbound will show all upgrades available on return flights.
            //showUpgradeBoth will show upgrades available on both flights.
            //showUpgradeAll will show all upgrades available no matter whether outbound, return or both.
            //Push upgrades into array.

            var pushUpgradesArray = [];
            var pushUpgradesInboundArray = [];
            var pushUpgradesOutboundArray = [];

            //Foreach flightUpgradesSection...
            $('.flightUpgradesSection').each(function () {
                //Get the data field.
                var getFlightUpgradeClass = $(this).data('flightupgradeclass');
                //Push the list of all the upgrade values into one array so they can be filtered below.
                pushUpgradesArray.push(getFlightUpgradeClass);
                pushUpgradesOutboundArray.push(getFlightUpgradeClass);
                pushUpgradesInboundArray.push(getFlightUpgradeClass);

                //If the data field contains outbound (has an outbound upgrade)...
                if (getFlightUpgradeClass.indexOf("outbound") >= 0) {
                    //Show the div surrounding the outbound button.
                    $('#showOutboundUpgradesBtn').show();
                    //On click of the button...
                    $('#showOutboundUpgrades').on('click', function () {
                        removeUpgradesClasses();

                        //Add the selected class when this button is clicked.
                        $(this).addClass('selected');

                        //If this button has a class of selected, add the circle dot class and remove the circle class.
                        if ($(this).hasClass('selected')) {
                            $(this).find('i').addClass('fa-dot-circle-o').removeClass('fa-circle-o');
                        }

                        //Remove all inbound items from the array so we can show only outbound upgrades.
                        var removeInboundE = "inbound|ECONOMY";
                        var removeInboundP = "inbound|PREMIUM";
                        var removeInboundPe = "inbound|PREMIUM ECONOMY";
                        var removeInboundB = "inbound|BUSINESS";
                        var removeInboundF = "inbound|FIRSTCLASS";
                        var outboundArray = pushUpgradesOutboundArray.filter(function(item) {
                            return item !== removeInboundP && item !== removeInboundB && item !== removeInboundF && item !== removeInboundPe && item !== removeInboundE;
                        });

                        //Pass this array to the next lvl so we can decide which buttons to show.
                        upgradesSecondLvl(outboundArray);
                    });
                }

                //If the data field contains inbound (has an inbound upgrade)...
                if (getFlightUpgradeClass.indexOf("inbound") >= 0) {
                    //Show the div surrounding the inbound button.
                    $('#showInboundUpgradesBtn').show();

                    //On click of the button...
                    $('#showInboundUpgrades').on('click', function () {
                        removeUpgradesClasses();

                        //Add the selected class when this button is clicked.
                        $(this).addClass('selected');

                        //If this button has a class of selected, add the circle dot class and remove the circle class.
                        if ($(this).hasClass('selected')) {
                            $(this).find('i').addClass('fa-dot-circle-o').removeClass('fa-circle-o');
                        }

                        //Remove all outbound items from the array so we can show only inbound upgrades.
                        var removeOutboundE = "outbound|ECONOMY";
                        var removeOutboundP = "outbound|PREMIUM";
                        var removeOutboundPe = "outbound|PREMIUM ECONOMY";
                        var removeOutboundB = "outbound|BUSINESS";
                        var removeOutboundF = "outbound|FIRSTCLASS";
                        var inboundArray = pushUpgradesOutboundArray.filter(function(item) {
                            return item !== removeOutboundP && item !== removeOutboundB && item !== removeOutboundF && item !== removeOutboundPe && item !== removeOutboundE;
                        });

                        //Pass this array to the next lvl so we can decide which buttons to show.
                        upgradesSecondLvl(inboundArray);
                    });
                }

                //If both the outbound and inbound upgrades buttons are visible, show the both button.
                if ($('#showOutboundUpgradesBtn').is(":visible") && $('#showInboundUpgradesBtn').is(":visible")) {
                    $('#showBothUpgradesBtn').show();

                    $('#showBothUpgrades').on('click', function () {
                        removeUpgradesClasses();

                        //Add the selected class when this button is clicked.
                        $(this).addClass('selected');

                        //If this button has a class of selected, add the circle dot class and remove the circle class.
                        if ($(this).hasClass('selected')) {
                            $(this).find('i').addClass('fa-dot-circle-o').removeClass('fa-circle-o');
                        }

                        //Pass this array to the next lvl so we can decide which buttons to show.
                        upgradesSecondLvl(pushUpgradesArray);
                    });
                }
            });


            function removeUpgradesClasses() {
                $('.flightUpgradesLvl1 .flightUpgradeButtons a').removeClass('selected');
                $('.flightUpgradesLvl2 .flightUpgradeButtons a').removeClass('selected');
                $('.flightUpgradesLvl1 .flightUpgradeButtons a i').addClass('fa-circle-o').removeClass('fa-dot-circle-o');
                $('.flightUpgradesLvl2 .flightUpgradeButtons a i').addClass('fa-circle-o').removeClass('fa-dot-circle-o');
                $('#showPremiumUpgradesBtn, #showBusinessUpgradesBtn, #showFirstUpgradesBtn').hide();
                $('.upgradesTable').hide();
            }

            function removeFirstUpgradeCorners() {
                var flightUpgradesSection = $(".flightUpgradesSection:visible");
                var firstFlightUpgradesSection = flightUpgradesSection.first();

                firstFlightUpgradesSection.find('td')
                    .css({
                        "border-top-left-radius": "0",
                        "border-top-right-radius": "0"
                    });

                flightUpgradesSection.not(firstFlightUpgradesSection).find('td').first().css("border-top-left-radius", "10px");
                flightUpgradesSection.not(firstFlightUpgradesSection).find('td').last().css("border-top-right-radius", "10px");
            }

            function upgradesSecondLvl(passUpgrades) {
                $('.flightUpgradesLvl2').show();

                if (passUpgrades.indexOf("outbound|PREMIUM") >= 0 || passUpgrades.indexOf("inbound|PREMIUM") >= 0 ||
                    passUpgrades.indexOf("outbound|PREMIUM ECONOMY") >= 0 || passUpgrades.indexOf("inbound|PREMIUM ECONOMY") >= 0 ||
                    passUpgrades.indexOf("outbound|ECONOMY") >= 0 || passUpgrades.indexOf("inbound|ECONOMY") >= 0) {

                    $('#showPremiumUpgradesBtn').show();

                    $('#showPremiumUpgrades').on('click', function () {
                        $('.flightUpgradesLvl2 .flightUpgradeButtons a').removeClass('selected');
                        $('.flightUpgradesLvl2 .flightUpgradeButtons a i').addClass('fa-circle-o').removeClass('fa-dot-circle-o');
                        $(this).addClass('selected');
                        //If this button has a class of selected, add the circle dot class and remove the circle class.
                        if ($(this).hasClass('selected')) {
                            $(this).find('i').addClass('fa-dot-circle-o').removeClass('fa-circle-o');
                        }
                        //Show the upgrades table.
                        $('.upgradesTable').show();
                        removeFirstUpgradeCorners();
                        //Get the button that has been clicked.
                        //Hide all div's that aren't the current one that has been clicked.
                        if ($('#showOutboundUpgradesBtn a').hasClass('selected')) {
                            $('.flightUpgradesSection').hide();
                            $('.flightUpgradesSection[data-flightupgradeclass="outbound|PREMIUM"]').show();
                            $('.flightUpgradesSection[data-flightupgradeclass="outbound|PREMIUM ECONOMY"]').show();
                            $('.flightUpgradesSection[data-flightupgradeclass="outbound|ECONOMY"]').show();
                        } else if ($('#showInboundUpgradesBtn a').hasClass('selected')) {
                            $('.flightUpgradesSection').hide();
                            $('.flightUpgradesSection[data-flightupgradeclass="inbound|PREMIUM"]').show();
                            $('.flightUpgradesSection[data-flightupgradeclass="inbound|PREMIUM ECONOMY"]').show();
                            $('.flightUpgradesSection[data-flightupgradeclass="inbound|ECONOMY"]').show();
                        } else if ($('#showBothUpgradesBtn a').hasClass('selected')) {
                            $('.flightUpgradesSection').hide();
                            $('[data-flightupgradeclass="outbound|PREMIUM"]').show();
                            $('[data-flightupgradeclass="inbound|PREMIUM"]').show();
                            $('[data-flightupgradeclass="outbound|PREMIUM ECONOMY"]').show();
                            $('[data-flightupgradeclass="inbound|PREMIUM ECONOMY"]').show();
                            $('[data-flightupgradeclass="outbound|ECONOMY"]').show();
                            $('[data-flightupgradeclass="inbound|ECONOMY"]').show();
                        }
                    });
                }

                if (passUpgrades.indexOf("outbound|BUSINESS") >= 0 || passUpgrades.indexOf("inbound|BUSINESS") >= 0) {
                    $('#showBusinessUpgradesBtn').show();
                    $('#showBusinessUpgrades').on('click', function () {
                        $('.flightUpgradesLvl2 .flightUpgradeButtons a').removeClass('selected');
                        $('.flightUpgradesLvl2 .flightUpgradeButtons a i').addClass('fa-circle-o').removeClass('fa-dot-circle-o');
                        $(this).addClass('selected');

                        //If this button has a class of selected, add the circle dot class and remove the circle class.
                        if ($(this).hasClass('selected')) {
                            $(this).find('i').addClass('fa-dot-circle-o').removeClass('fa-circle-o');
                        }

                        //Show the upgrades table.
                        $('.upgradesTable').show();
                        removeFirstUpgradeCorners();

                        //Get the button that has the selected class.
                        //Hide all div's that are related to the button that has been clicked e.g first button clicked was
                        //outbound, and second button was business - show all outbound business upgrades.
                        if ($('#showOutboundUpgradesBtn a').hasClass('selected')) {
                            $('.flightUpgradesSection').hide();
                            $('.flightUpgradesSection[data-flightupgradeclass="outbound|BUSINESS"]').show();
                        } else if ($('#showInboundUpgradesBtn a').hasClass('selected')) {
                            $('.flightUpgradesSection').hide();
                            $('.flightUpgradesSection[data-flightupgradeclass="inbound|BUSINESS"]').show();
                        } else if ($('#showBothUpgradesBtn a').hasClass('selected')) {
                            $('.flightUpgradesSection').hide();
                            $('[data-flightupgradeclass="outbound|BUSINESS"]').show();
                            $('[data-flightupgradeclass="inbound|BUSINESS"]').show();
                        }
                    });
                }

                if (passUpgrades.indexOf("outbound|FIRSTCLASS") >= 0 || passUpgrades.indexOf("inbound|FIRSTCLASS") >= 0) {
                    $('#showFirstUpgradesBtn').show();
                    $('#showFirstUpgrades').on('click', function () {
                        $('.flightUpgradesLvl2 .flightUpgradeButtons a').removeClass('selected');
                        $('.flightUpgradesLvl2 .flightUpgradeButtons a i').addClass('fa-circle-o').removeClass('fa-dot-circle-o');
                        $(this).addClass('selected');

                        //If this button has a class of selected, add the circle dot class and remove the circle class.
                        if ($(this).hasClass('selected')) {
                            $(this).find('i').addClass('fa-dot-circle-o').removeClass('fa-circle-o');
                        }

                        $('.upgradesTable').show();
                        removeFirstUpgradeCorners();

                        if ($('#showOutboundUpgradesBtn a').hasClass('selected')) {
                            $('.flightUpgradesSection').hide();
                            $('.flightUpgradesSection[data-flightupgradeclass="outbound|FIRSTCLASS"]').show();
                        } else if ($('#showInboundUpgradesBtn a').hasClass('selected')) {
                            $('.flightUpgradesSection').hide();
                            $('.flightUpgradesSection[data-flightupgradeclass="inbound|FIRSTCLASS"]').show();
                        } else if ($('#showBothUpgradesBtn a').hasClass('selected')) {
                            $('.flightUpgradesSection').hide();
                            $('[data-flightupgradeclass="outbound|FIRSTCLASS"]').show();
                            $('[data-flightupgradeclass="inbound|FIRSTCLASS"]').show();
                        }
                    });
                }
            }
        }
    }
});
